/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import config from '@config';
import InsightCard from '@moms/Cards/InsightCard';

/* Styles */
import InsightSt from '@moms/styleData/InsightSt';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const MiracleOfMindBlogTabGroup = ({ region, lang, sectionContent }) => {
  const [sliderArray, setSliderArray] = useState([]);
  const [tabObj, setTabObj] = useState({});
  const [selectedTab, setSelectedTab] = useState(0);

  const cardsHandler = () => {
    const arr = [];
    const obj = {};
    const localObj = filter(config.locales, function (locale, index) {
      return (
        locale?.region_sf === (lang === 'en' ? 'in' : region) &&
        locale?.language_sf === lang
      );
    })[0];
    // console.log('localObj', localObj);
    if (sectionContent.cards.length === 1) {
      sectionContent?.cards[0]?.cards?.map(el => {
        el?.locales.forEach(item => {
          item.parentTitle = el.parentContent.title
            ? el.parentContent.title
            : '';
          item.parentUrl = el.parentContent.urlAlias
            ? el.parentContent.urlAlias
            : '';
          item.currLocale = item._locales[0];
        });
        const reqLocaleObj = filter(el?.locales, function (locale, index) {
          return locale?._locales.indexOf(localObj?.available_local) > -1;
        });

        if (reqLocaleObj?.length) {
          arr.push(reqLocaleObj[0]);
        }
      });
      // console.log('all array', arr);
      setSliderArray(prev => prev.concat(...arr));
    } else {
      sectionContent.cards?.map(el => {
        obj[el.tabTitle] = el.cards;
      });
    }
    if (Object.keys(obj).length > 0) {
      const objKeys = Object.keys(obj);
      objKeys.forEach(el => {
        let keyArr = [];
        obj[el]?.map(item => {
          item.locales.forEach(card => {
            card.parentTitle = item.parentContent.title
              ? item.parentContent.title
              : '';
            card.parentUrl = item.parentContent.urlAlias
              ? item.parentContent.urlAlias
              : '';
          });
          // console.log(
          //   'sectionContent22',
          //   localObj?.available_local,
          //   item,
          //   item.locales[0]?._locales[0]
          // );
          const reqLocaleObj = filter(item?.locales, function (locale, index) {
            return locale?._locales.indexOf(localObj?.available_local) > -1;
          });
          if (reqLocaleObj?.length) {
            keyArr.push(reqLocaleObj[0]);
            // console.log('reqLocaleObj', reqLocaleObj);
          }
        });
        obj[el] = keyArr;
      });
    }
    // console.log('obj', obj);
    setTabObj(obj);
  };

  useEffect(() => {
    cardsHandler();
  }, [sectionContent]);

  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        zIndex={1}
        borderRadius="50%"
        position={'absolute'}
        right={{ md: '-9%', lg: '-13%' }}
        top={{ md: '35%', lg: '38%' }}
        bgPosition="center"
        boxShadow={'xl'}
        bgSize="cover"
        boxSize="62px"
        overflow="visible"
        display={{ base: 'none', md: 'flex' }}
        alignItems="center"
        justifyContent="center"
        color="#FFF"
        cursor="pointer"
        padding="0"
      >
        <IoIosArrowForward fontSize="2.5rem" />
      </Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        borderRadius="50%"
        bgPosition="center"
        bgSize="cover"
        zIndex={1000}
        boxShadow={'xl'}
        position={'absolute'}
        left={{ md: '-10%', lg: '-7%', xl: '-12%' }}
        top={{ md: '35%', lg: '38%' }}
        boxSize="62px"
        overflow="visible"
        display={{ base: 'none', md: 'flex' }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        fontSize="1rem"
        padding="0"
        color="#FFF"
      >
        <IoIosArrowBack fontSize="2.5rem" />
      </Box>
    );
  };
  const twoSlide = {
    slidesToShow: 2,
    slidesToScroll: 2,
  };
  const settings = {
    dots: true,
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1224,
        settings: sliderArray.length > 2 ? twoSlide : 'unslick',
      },

      {
        breakpoint: 1024,
        settings: sliderArray.length > 2 ? twoSlide : 'unslick',
      },
      {
        breakpoint: 768,
        settings: sliderArray.length > 2 ? twoSlide : 'unslick',
      },
      {
        breakpoint: 586,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],

    customPaging: i => (
      <Box
        width={{ base: '11.39px' }}
        height={{ base: '11.39px' }}
        borderRadius="50%"
        mt={{ base: '2rem', lg: '4rem' }}
        marginRight="1rem"
        bgColor=" #FFFFFF33"
        transition="background-color 0.3s, opacity 0.3s"
        css={{
          '.slick-active &': {
            backgroundColor: '#EC1C2D',
            opacity: '1',
          },
        }}
        _hover={{ bgColor: '#08152D' }}
      />
    ),
  };
  const tabSettings = {
    dots: true,
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1224,
        settings:
          Object.values(tabObj)[selectedTab]?.length > 2 ? twoSlide : 'unslick',
      },

      {
        breakpoint: 1024,
        settings:
          Object.values(tabObj)[selectedTab]?.length > 2 ? twoSlide : 'unslick',
      },
      {
        breakpoint: 768,
        settings:
          Object.values(tabObj)[selectedTab]?.length > 2 ? twoSlide : 'unslick',
      },
      {
        breakpoint: 586,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],

    customPaging: i => (
      <Box
        width={{ base: '11.39px' }}
        height={{ base: '11.39px' }}
        borderRadius="50%"
        mt={{ base: '2rem', lg: '4rem' }}
        marginRight="1rem"
        bgColor=" #FFFFFF33"
        transition="background-color 0.3s, opacity 0.3s"
        css={{
          '.slick-active &': {
            backgroundColor: '#EC1C2D',
            opacity: '1',
          },
        }}
        _hover={{ bgColor: '#08152D' }}
      />
    ),
  };
  return (
    <Box pt={{ base: '2rem', md: '2rem' }} pb={'12rem'}>
      {/* heading2 */}
      <Box
        mx={'auto'}
        maxW={{ base: '300px', md: '100%' }}
        {...InsightSt?.[lang]?.SubHeading}
        mt="0"
      >
        {sectionContent.title}
      </Box>

      {/* tabs container */}
      {/* Extract tabs dynamically */}
      {/* {sectionContent?.cards?.some(tab => tab.tabTitle) && ( */}
      <Box
        display="flex"
        gap={{ base: '.1rem', md: '3rem' }}
        justifyContent="center"
        mt={{ base: '3rem', md: '3rem' }}
        borderBottom={'1px solid #414141'}
      >
        {Object.keys(tabObj).length > 0 &&
          Object.keys(tabObj).map((tab, index) => (
            <Text
              key={index}
              {...InsightSt?.[lang]?.TabsText}
              pos="relative"
              display="inline-block"
              // _before={{
              //   content: "''",
              //   position: 'relative',
              //   display: selectedTab === tab ? 'block' : 'none',
              //   bottom: '-2.34rem',
              //   left: '0',
              //   right: '0',
              //   height: '1px',
              //   maxW: '58px',
              //   width: '58px',
              //   background: '#ff0000',
              // }}
              borderBottom={
                selectedTab === index ? '3px solid #ff0000' : 'none'
              }
              p="0 20px 1rem 20px"
              mb="-2px"
              maxW="33%"
              color={selectedTab === index ? '#FFFFFF' : '#878787'}
              cursor="pointer"
              onClick={() => setSelectedTab(index)} // Update state with correct tabTitle
            >
              {tab}
            </Text>
          ))}
      </Box>
      {/* )} */}

      <Box
        mt={{ base: '2rem', md: '3rem' }}
        bg="none"
        maxWidth={{
          base: '1000px',
          md: '640px',
          lg: '650px',
          xl: '1000px',
          '2xl': '1000px',
        }}
        mx="auto"
        height="auto"
        width="100%"
        pos="relative"
        className="sliderExpressions"
      >
        <Box
          w="calc(100% - 3rem)"
          position="absolute"
          left="1.5rem"
          height="50%"
          top={0}
          right="1.5rem"
          bottom={0}
          boxShadow="0px 1046px 249.8px 0px rgba(153, 192, 255, 0.00), 0px 669px 268px 0px rgba(153, 192, 255, 0.01), 0px 377px 226px 0px rgba(153, 192, 255, 0.04), 0px 167px 165.4px 0px rgba(153, 192, 255, 0.05), 0px 42px 89.8px 0px rgba(153, 192, 255, 0.05)"
          zIndex={10}
        ></Box>
        <Box pos="relative" zIndex="11">
          {Object.values(tabObj)?.[selectedTab]?.length > 0 && (
            <>
              {Object.values(tabObj)[selectedTab].length > 2 ? (
                <Slider {...tabSettings} style={{ bg: 'transparent' }}>
                  {Object.values(tabObj)[selectedTab]?.map((card, index) => {
                    if (card.title === '') {
                      return;
                    }
                    return <InsightCard key={index} card={card} lang={lang} />;
                  })}
                </Slider>
              ) : (
                <Flex>
                  {Object.values(tabObj)[selectedTab]?.map((card, index) => {
                    if (card.title === '') {
                      return;
                    }
                    return (
                      <InsightCard
                        height="310px"
                        key={nanoid()}
                        card={card}
                        lang={lang}
                      />
                    );
                  })}
                </Flex>
              )}
            </>
          )}
          {sliderArray.length > 0 && (
            <>
              {sliderArray.length > 2 ? (
                <Slider {...settings} style={{ bg: 'transparent' }}>
                  {sliderArray?.map((card, index) => {
                    if (card.title === '') {
                      return;
                    }
                    return <InsightCard key={index} card={card} lang={lang} />;
                  })}
                </Slider>
              ) : (
                <Flex>
                  {Object.values(tabObj)[selectedTab]?.map((card, index) => {
                    if (card.title === '') {
                      return;
                    }
                    return (
                      <InsightCard
                        height="310px"
                        key={nanoid()}
                        card={card}
                        lang={lang}
                      />
                    );
                  })}
                </Flex>
              )}
            </>
          )}
        </Box>
      </Box>
      <style jsx global>
        {`
          .sliderExpressions .slick-dots li {
            margin: 0 0px; /* Adjust the space between dots */
          }
        `}
      </style>
    </Box>
  );
};

export default MiracleOfMindBlogTabGroup;
